function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M126.767,195.158c0,5.362,4.347,9.709,9.709,9.709c5.362,0,9.709-4.347,9.709-9.709V171.21h23.948 c5.362,0,9.709-4.347,9.709-9.709c0-5.362-4.347-9.709-9.709-9.709h-23.948v-23.948c0-5.362-4.347-9.709-9.709-9.709 c-5.362,0-9.709,4.347-9.709,9.709v23.948h-23.948c-5.362,0-9.709,4.347-9.709,9.709c0,5.362,4.347,9.709,9.709,9.709h23.948 V195.158z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.535,307.132c-23.912,0-43.366,19.454-43.366,43.366s19.454,43.366,43.366,43.366 c23.912,0,43.366-19.454,43.366-43.366C190.901,326.586,171.447,307.132,147.535,307.132z M147.535,374.446 c-13.205,0-23.948-10.743-23.948-23.948s10.743-23.948,23.948-23.948s23.948,10.743,23.948,23.948 C171.483,363.701,160.74,374.446,147.535,374.446z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M320.111,183.773c-1.522-5.142-6.923-8.076-12.065-6.555c-3.619,1.072-89.156,27.261-133.145,116.562 c-2.37,4.81-0.391,10.629,4.419,12.999c1.38,0.68,2.841,1.002,4.282,1.001c3.582,0,7.028-1.991,8.717-5.421 c40.04-81.285,120.119-106.185,121.244-106.525C318.7,194.31,321.63,188.912,320.111,183.773z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M469.929,31.938H42.071C18.874,31.938,0,50.812,0,74.009v363.982c0,23.197,18.874,42.071,42.071,42.071h427.858 c23.197,0,42.071-18.874,42.071-42.071V74.009C512,50.81,493.126,31.938,469.929,31.938z M317.45,460.645H194.552v-32.362H317.45 V460.645z M71.197,408.865v-305.73h369.606v305.73H71.197z M492.583,437.991c0,12.491-10.163,22.654-22.654,22.654h-133.06 v-32.362h113.642c5.362,0,9.709-4.347,9.709-9.709V93.426c0-5.362-4.347-9.709-9.709-9.709H61.489 c-5.362,0-9.709,4.347-9.709,9.709v325.147c0,5.362,4.347,9.709,9.709,9.709h113.646v32.362H42.071 c-12.491,0-22.654-10.163-22.654-22.654V74.009c0-12.491,10.163-22.654,22.654-22.654h427.858 c12.491,0,22.654,10.163,22.654,22.654V437.991z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.426,127.749c-23.912,0-43.366,19.454-43.366,43.366s19.454,43.366,43.366,43.366s43.366-19.454,43.366-43.366 S395.337,127.749,371.426,127.749z M371.426,195.062c-13.205,0-23.948-10.743-23.948-23.948s10.743-23.948,23.948-23.948 s23.948,10.743,23.948,23.948S384.631,195.062,371.426,195.062z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.246,318.015h-23.948v-23.948c0-5.362-4.347-9.709-9.709-9.709c-5.362,0-9.709,4.347-9.709,9.709v23.948h-23.948 c-5.362,0-9.709,4.347-9.709,9.709s4.347,9.709,9.709,9.709h23.948v23.948c0,5.362,4.347,9.709,9.709,9.709 c5.362,0,9.709-4.347,9.709-9.709v-23.948h23.948c5.362,0,9.709-4.347,9.709-9.709 C397.955,322.362,393.608,318.015,388.246,318.015z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgBoard = function SvgBoard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/board.4cc2c698.svg";
export { ForwardRef as ReactComponent };